import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import InputMask from 'react-input-mask';
import Select from 'react-select';

import Overlay from '../Miscelania/Overlay';
import getLocale from '../../i18n/getLocale';

class StaffDiscrepanciesAdd extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      discrepancy: null,
      stress_rate: null,
      date: null,
      staff_discrepancies: {},
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.locale = getLocale();

    this.add = this.add.bind(this);
    this.loadData = this.loadData.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }
  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }
  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/tripulante/discrepancias';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({ staff_discrepancies: responseJson.data.staff_discrepancies, staff_id: responseJson.data.staff_id});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
      });
    });
  }

  add(event) {
    event.preventDefault();
    var datasave = {
      staff_id: this.state.staff_id,
      date: this.state.date,
      discrepancy: this.state.discrepancy,
      stress_rate: this.state.stress_rate,
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/tripulante/discrepancia', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({ staff_discrepancies: responseJson.data });
        }
        self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.TripulanteDiscrepancias.AdicionarDiscrepancia.titulo}</h3>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.add}>
        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.TripulanteDiscrepancias.AdicionarDiscrepancia.formulario.Data}:</label>
              <InputMask value={this.state.date}  maskChar={null} name="date" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date')} placeholder=""  required/>
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.TripulanteDiscrepancias.AdicionarDiscrepancia.formulario.Discrepancia}:</label>
              <input type="text" name="discrepancy" className="form-control" placeholder={''} value={this.state.discrepancy} onChange={this.handleChange.bind(this, 'discrepancy')} required />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.TripulanteDiscrepancias.AdicionarDiscrepancia.formulario.grauEstresse}:</label>
              <Select
                  className="form-field-name"
                  name="stress_rate"
                  value={this.state.stress_rate}
                  searchable={true}
                  placeholder={''}
                  onChange={this.handleSelectChange.bind(this, 'stress_rate')}
                  options={[
                    {value: '1', label: '1'},
                    {value: '2', label: '2'},
                    {value: '3', label: '3'},
                    {value: '4', label: '4'},
                    {value: '5', label: '5'},
                  ]}
                  required
                />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.TripulanteDiscrepancias.AdicionarDiscrepancia.formulario.botaoAdicionar}</button>
          </div>
        </div>
      </form>
      <hr />
      <h3 className="page-title">{this.locale.TripulanteDiscrepancias.AdicionarDiscrepancia.tituloAnteriores}</h3>
      <hr />
      <div className="table-responsive">
          <table className="table table-bordered table-hover table-striped">
              <thead>
                  <tr>
                      <th>{this.locale.TripulanteDiscrepancias.AdicionarDiscrepancia.tabela.Data}</th>
                      <th>{this.locale.TripulanteDiscrepancias.AdicionarDiscrepancia.tabela.Discrepancia}</th>
                      <th>{this.locale.TripulanteDiscrepancias.AdicionarDiscrepancia.tabela.grauEstresse}</th>
                  </tr>
              </thead>
              <tbody id="dates">
                  {Object.keys(self.state.staff_discrepancies).map(function(k) {
                      var staff_discrepancy = self.state.staff_discrepancies[k];
                      return (
                      <tr>
                          <td>{staff_discrepancy.date_str}</td>
                          <td>{staff_discrepancy.discrepancy}</td>
                          <td>{staff_discrepancy.stress_rate}</td>
                      </tr>
                      );
                  })}
              </tbody>
          </table>
      </div>
    </div>
  </div>
</div>
    );
  }
}

export default StaffDiscrepanciesAdd;



// WEBPACK FOOTER //
// ./src/Components/StaffDiscrepancies/StaffDiscrepanciesAdd.js